import React from 'react'
import { useEffect, useState } from 'react';
import axios from 'axios';
import AuthUser from './AuthUser';
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from 'react-router-dom';

export default function Jacanti() {
    const navigate = useNavigate();
    const { http, user } = AuthUser();
    const [users, setUsers] = useState([]);
    const [reminderTypes, setReminderTypes] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [formData, setFormData] = useState({
        type: '',
        status: '',
        assigned_to: '',
        company_name: '',
        location: '',
        contact: '',
        contact_name:'',
        katze_person: '',
        classification: '',
        duration: '',
        total_system: '',
        others: '',
        rate: '',
        amount: '',
        start_date: '',
        end_date: '',
        distance: '',
        licence: '',
        remark: '',
        ext1:user.id
      

    });

    const initialState = {
        type: '',
        status: '',
        assigned_to: '',
        company_name: '',
        contact_name:'',
        location: '',
        contact: '',
        katze_person: '',
        classification: '',
        duration: '',
        total_system: '',
        others: '',
        rate: '',
        amount: '',
        start_date: '',
        end_date: '',
        distance: '',
        licence: '',
        remark: '',
        ext1:user.id
    }

    const calculateEndDate = (startDate, duration) => {
        if (startDate && duration && !Number.isNaN(Number(duration))) {
            const [y, m, d] = startDate.split("-").map(Number);
            const start = new Date(y, m - 1, d);
            start.setDate(start.getDate() + parseInt(duration, 10));
            const yy = start.getFullYear();
            const mm = String(start.getMonth() + 1).padStart(2, "0");
            const dd = String(start.getDate()).padStart(2, "0");
            return `${yy}-${mm}-${dd}`;
        }
        return "";
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        const updated = { ...formData, [name]: value };

        if (name === "start_date" || name === "duration") {
            const startDate = name === "start_date" ? value : formData.start_date;
            const duration = name === "duration" ? value : formData.duration;
            updated.end_date = calculateEndDate(startDate, duration);
        }

        setFormData(updated);
    };

    useEffect(() => {
        http.get(`/department_user_company?&login_user=${user.id}`).then((res) => {
            setUsers(res.data.users);
        });
        http.get('/reminder_types').then((res) => {
            if (res.data.success) {
                setReminderTypes(res.data.data);
            }
        });
        http.get('/get_customer_dropdown').then((res) => {
            setCustomers(res.data.customers);
        });
    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault();

        const form = new FormData();
        for (const key in formData) {
            form.append(key, formData[key]);
        }
        try {
            http.post('/anti_add_job', form, {
                
            }).then((res) => {
                toast.success("Reminder added successfully !");
                setFormData(initialState);
                navigate('/jobcart/reminder');
            })

        } catch (error) {
            console.error('Error adding company:', error.response.data);
        }
    };
  return (
   <>
    
    <div className="container mt-5">
                <Toaster />
                <h3>Add Virus</h3>
                <form onSubmit={handleSubmit}>
                    <div className='form-group mt-3'>
                        <label>Type</label>
                       <select name='type' className='form-control' value={formData.type} onChange={handleChange}>
                            <option value="">Select Any</option>
                            {reminderTypes.map((type) => (
                                <option key={type.id} value={type.name}>
                                    {type.name}
                                </option>
                            ))}
                        </select>  
                    </div>

                    <div className='form-group mt-3'>
                        <label>Status</label>
                       <select name='status' className='form-control' value={formData.status} onChange={handleChange}>
                            <option value="">Select Any</option>
                            <option value="NEW">NEW</option>
                            <option value="RE-NEW">RE-NEW</option>
                            <option value="LEFT">LEFT</option>
                            <option value="STOPPED">STOPPED</option>
                        </select>  
                    </div>

                    <div className='form-group mt-3'>
                        <label>Comapany Name</label>
                        <select
                            name="company_name"
                            className='form-control'
                            value={formData.company_name}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Select Company</option>
                            {customers.map(customer => (
                                <option key={customer.id} value={customer.company}>{customer.company}</option>
                            ))}
                        </select>
                    </div>

                    <div className='form-group mt-3'>
                        <label>Location</label>
                        <input
                            name="location"
                            className='form-control'
                            value={formData.location}
                            onChange={handleChange}
                            required
                        />    
                    </div>

                    <div className='form-group mt-3'>
                        <label>Customer Contact Name</label>
                        <input
                            name="contact_name"
                            className='form-control'
                            value={formData.contact_name}
                            onChange={handleChange}
                            required
                        />    
                    </div>


                    <div className='form-group mt-3'>
                        <label>Contact Number</label>
                        <input
                            name="contact"
                            className='form-control'
                            value={formData.contact}
                            onChange={handleChange}
                            required
                        />    
                    </div>

                
                    <div className='form-group  mt-3'>
                        <label>Katze Person</label>
                        <select disabled={!users.length}
                            name="katze_person"
                            className='form-control text-uppercase'
                            value={formData.katze_person}
                            onChange={handleChange}
                            required 
                        >
                            <option value="">Select a user</option>
                            {users.map(user => (
                                <option key={user.id} value={user.id}>{user.name} {user.last_name}</option>
                            )
                            )}
                        </select>
                    </div>

                    <div className='form-group mt-3'>
                        <label>Sub-Classification</label>
                        <input
                            name="classification"
                            className='form-control'
                            value={formData.classification}
                            onChange={handleChange}
                            
                        />    
                    </div>

                    <div className='form-group mt-3'>
                        <label>Others</label>
                        <input
                            name="others"
                            className='form-control'
                            value={formData.others}
                            onChange={handleChange}
                            
                        />    
                    </div>

                    <div className='form-group mt-3'>
                        <label>Total Systems</label>

                        <input
                            name="total_system"
                            className='form-control'
                            value={formData.total_system}
                            onChange={handleChange}
                            required
                        />    
                    </div>

                 

                    <div className='form-group mt-3'>
                        <label>Rate</label>

                        <input
                            name="rate"
                            className='form-control'
                            value={formData.rate}
                            onChange={handleChange}
                            required
                        />    
                    </div>

                    <div className='form-group mt-3'>
                        <label>Total Amount</label>

                        <input
                            name="amount"
                            className='form-control'
                            value={formData.amount}
                            onChange={handleChange}
                            required
                        />    
                    </div>

                    <div className='form-group mt-3'>
                        <label>Starting Date</label>

                        <input
                            name="start_date"
                            type='date'
                            className='form-control'
                            value={formData.start_date}
                            onChange={handleChange}
                            required
                        />    
                    </div>

                    <div className='form-group mt-3'>
                        <label>Duration (days)</label>
                        <input
                            name="duration"
                            type="number"
                            min="1"
                            className='form-control'
                            value={formData.duration}
                            onChange={handleChange}
                            placeholder="e.g. 365"
                            required
                        />
                    </div>

                    <div className='form-group mt-3'>
                        <label>End Date</label>

                        <input
                            name="end_date"
                            type='date'
                            className='form-control'
                            value={formData.end_date}
                            onChange={handleChange}
                            required
                            readOnly={Boolean(formData.start_date && formData.duration)}
                        />
                        {formData.start_date && formData.duration ? (
                            <small className="text-muted">Auto-calculated from start date + duration</small>
                        ) : null}
                    </div>

                    <div className='form-group mt-3'>
                        <label>Location Distance</label>

                        <input
                            name="distance"
                            className='form-control'
                            value={formData.distance}
                            onChange={handleChange}
                            required
                        />    
                    </div>

                    <div className='form-group mt-3'>
                        <label>Licence</label>

                        <input
                            name="licence"
                            className='form-control'
                            value={formData.licence}
                            onChange={handleChange}
                            
                        />    
                    </div>

                    
                    <div className='form-group mt-3'>
                        <label>Remarks</label>
                        <textarea
                            name="remark"
                            className='form-control'
                            rows="3"
                            value={formData.remark}
                            onChange={handleChange}
                            placeholder="Enter remarks"
                        />
                    </div>

                    <div className='form-group mt-3'>
                        <label>Address</label>
                       <textarea name='address'  onChange={handleChange} className='form-control' ></textarea>
                    </div>
                    <button className='btn button btn-success mt-3' type="submit">Add</button>
                </form>
            </div>
   </>
  )
}
